/**
 * The small renewal summary in the account panel. Like /account's full
 * subscription manager it reads the server-derived billing view model
 * (`GET /api/stripe/accountState`) rather than a cached user field — Tier 3b
 * retired `renewalMonths`, and the plan forbids inferring billing state from
 * the legacy cache (docs/todos/tasks/stripeRefactor.md).
 */
import * as preact from "preact";

import readlangClient from "readlangClient";

/** Just the fields this summary needs from the /accountState view model. */
interface AccountState {
  type: string;
  cancelAtPeriodEnd?: boolean;
  currentPeriodEnd?: string;
  billingStartsAt?: string;
  endsAt?: string;
}

type State = { accountState: AccountState | undefined };

const formatDate = (isoDate: string) => new Date(isoDate).toDateString();

/** The date the account next renews or runs out, whichever it has. */
const nextDate = (accountState: AccountState) =>
  accountState.currentPeriodEnd ??
  accountState.billingStartsAt ??
  accountState.endsAt;

class AccountRenewalView extends preact.Component<{}, State> {
  constructor() {
    super();
    this.state = { accountState: undefined };
    readlangClient.request(
      "GET",
      "/api/stripe/accountState",
      {},
      (accountState: AccountState) => this.setState({ accountState }),
      // A failed load leaves the summary out entirely: the link below opens
      // the page that can actually answer, so a wrong answer is worse than
      // none.
      () => this.setState({ accountState: undefined })
    );
  }

  render() {
    const { accountState } = this.state;
    const renews =
      accountState !== undefined &&
      (accountState.type === "stripeSubscription" ||
        accountState.type === "stripeBridge") &&
      !accountState.cancelAtPeriodEnd;
    const date = accountState && nextDate(accountState);

    return (
      <div>
        <h2 style={{ textAlign: "center" }}>Your renewal settings</h2>
        {date ? (
          <p>
            {renews ? "Next payment due" : "Access ends"}: &nbsp;
            {formatDate(date)}
          </p>
        ) : null}
        {accountState ? (
          <p>{renews ? "Auto-Renew Enabled" : "Auto-Renew Disabled"}</p>
        ) : null}
        <a
          class="payButton"
          href="/accountRenew"
          style={{ maxWidth: 300, margin: "10px auto" }}
        >
          Edit Renew Settings
        </a>
      </div>
    );
  }
}

export default AccountRenewalView;
